import script from "./zmr_menu.vue?vue&type=script&setup=true&lang=js"
export * from "./zmr_menu.vue?vue&type=script&setup=true&lang=js"

import "./zmr_menu.vue?vue&type=style&index=0&id=2819cb8c&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2819cb8c"]])

export default __exports__